import React from "react";
import Component from "./component";
function Container()
{
    return <Component />
}
export default Container;